import axios from "axios";

class Tutorial {
    constructor() {
        this.needsTutorial = "true";
        this.pageName = document.body.dataset.name;
        this.currentStep = 1;
        this.btnsStart = document.querySelectorAll(".start-tut-js");
        this.events();
    }

    events() {

        // eslint-disable-next-line no-unused-expressions
        this.needsTutorial = localStorage.getItem("needs_tutorial")
            ? localStorage.getItem("needs_tutorial")
            : "true";
        if (this.needsTutorial === "true") {
            this.steps = document.querySelectorAll(".tutorial-step-js");
            this.getTut();
            this.startTutorial();
        }

        if (this.btnsStart.length > 0) {
            this.btnsStart.forEach((el) => {

                el.addEventListener("click", (e) => {

                    this.needsTutorial = "true";
                    if (document.querySelectorAll(".tutorial-step-js").length > 0) {
                        localStorage.setItem("needs_tutorial", this.needsTutorial)
                        window.location.reload()
                    } else {
                        alert("Na tej podstronie samouczek jest niedostępny")
                    }

                })
            })
        }
    }

    getTut() {
        this.steps.forEach((el, key) => {
            const data = new FormData();
            data.append("action", "tutorial");
            data.append("tut_step", el.dataset.tutstep);
            data.append("page", el.dataset.page);
            data.append("pageName", this.pageName);
            axios
                .post(ajax.ajax_url, data)
                .then((res) => {
                    const temp = document.createElement("div");
                    temp.classList.add("tutorial");
                    temp.classList.add("tutorial__step");
                    temp.dataset.stepOrder = el.dataset.tutstep;
                    temp.dataset.page = el.dataset.page;
                    const templateHTML = JSON.parse(res.data.data);
                    temp.innerHTML = templateHTML || "";
                    temp.querySelector(".tutorial__btn--skip").addEventListener(
                        "click",
                        (e) => {
                            e.stopPropagation()
                            this.needsTutorial = "false";
                            localStorage.setItem(
                                "needs_tutorial",
                                this.needsTutorial
                            );
                            this.reset();
                        }
                    );
                    temp.querySelector(".tutorial__btn--next").addEventListener(
                        "click",
                        (e) => {
                            e.stopPropagation()
                            this.incrementStep();
                        }
                    );

                    this.setPositionOfStep(el, temp);
                    if (temp.dataset.stepOrder === "1") {

                        temp.style.display = "flex";
                        window.scrollTo({
                            top: el.getBoundingClientRect().y + 100,
                            behavior: "smooth"
                        })
                    }
                    el.appendChild(temp);
                })

                .catch((err) => {

                });
        });
    }

    getPositionOfSteps(step) {
        return {
            X: step.getBoundingClientRect().left,
            Y:
                document.documentElement.scrollHeight -
                (document.documentElement.scrollHeight -
                    step.getBoundingClientRect().top),
        };
    }

    setPositionOfStep(el, temp) {
        const indicator = document.createElement("div");

        indicator.classList.add("tutorial__indicator");

        // elements closes to right border of website
        if (
            this.getPositionOfSteps(el).X > window.innerWidth / 2 &&
            el.clientWidth < 200
        ) {
            if (window.innerWidth > 768) {
                temp.style.left = `-100%`;
                temp.style.top = `50%`;
                temp.style.transform = "translate(-100%, -50%)";
            } else {
                temp.style.left = `50%`;
                temp.style.top = `315%`;
                temp.style.transform = "translate(-95%, -75%)";
            }
            indicator.style.transform = "rotate(135deg) translateX(50%)";
            indicator.style.top = "40%";
            indicator.style.right = "-9px";
            indicator.dataset.here = "true";
            temp.appendChild(indicator);
            // elements closes to left border of website
        } else if (
            this.getPositionOfSteps(el).X < window.innerWidth / 2 &&
            el.clientWidth < 200
        ) {

            if (window.innerWidth > 768) {
                temp.style.left = `0`;
                temp.style.bottom = `-170px`;
            } else {
                temp.style.left = `50%`;
                temp.style.bottom = `-150px`;
                temp.style.transform = "translate(-50%, 27%)";
            }

            indicator.style.transform = "rotate(135deg) translateX(50%)";
            indicator.style.top = "-9px";
            indicator.style.left = "20px";
            temp.appendChild(indicator);
            // other  wide elements
        } else {
            temp.style.left = `50%`;
            temp.style.top = `100%`;
            temp.style.transform = "translateX(-50%)";
            indicator.style.transform = "rotate(135deg) translateX(50%)";
            indicator.style.top = "-9px";
            indicator.style.left = "20px";
            temp.appendChild(indicator);
        }
    }

    startTutorial() {
        const steps = document.querySelectorAll(".tutorial__step");
        steps.forEach((step) => {
            if (step.dataset.stepOrder === this.currentStep) {
                step.style.display = "flex"
                step.scrollIntoView(
                    {
                        behavior: "smooth"
                    }
                );
                // window.scrollTo({
                //     top: step.getBoundingClientRect().y,
                //     behavior: "smooth"
                // })
            } else {
                step.style.display = "none"
            }

        });
    }

    incrementStep() {
        const steps = document.querySelectorAll(".tutorial__step");
        this.needsTutorial = "false";
        localStorage.setItem("needs_tutorial", this.needsTutorial)
        if (this.currentStep <= steps.length) {
            this.currentStep++;
            steps.forEach((el, i) => {
                if (el.dataset.stepOrder === this.currentStep.toString()) {
                    el.style.display = "flex";
                    el.scrollIntoView(
                        {
                            block: "center",
                            behavior: "smooth"
                        }
                    );
                    // window.scrollTo({
                    //     top: el.getBoundingClientRect().y,
                    //     behavior: "smooth"
                    // })
                } else {
                    el.style.display = "none";
                }
            });
        } else {
            this.currentStep = 1;


            this.reset();
        }
    }


    reset() {
        const steps = document.querySelectorAll(".tutorial__step");
        steps.forEach((step) => step.remove());
    }
}

export default Tutorial;
